<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-公司动态">
    <mClass :nav="nav"></mClass>
  </div>
</template>
<script>
import mClass from "@/components/mClass.vue";
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
      nav: [
        { title: "行业动态", url: "mhydt" },
        { title: "机构动态", url: "mjgdt" },
        { title: "项目动态", url: "mxmdt" },
        { title: "活动展示", url: "mhdzs" },
      ]
    };
  },
  mounted() {
    this.$nextTick(function() {
      Bus.$emit("getpCurrent", "mNews");
    });
  },
  methods: {},
  components: {
    mClass
  }
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
}
</style>